import { connect } from 'react-redux';
import {setCurrentAppointment, setTimeslotMenuIsOpen} from "../../redux/timeslots/actions";
import TimeSlotGroup from "./TimeSlotGroup";

const mapDispatchToProps = {
  setTimeslotMenuIsOpen,
  setCurrentAppointment
};

const mapStateToProps = (state) => ({
  timeslotMenuIsOpened: state.timeslotsReducer.timeslotMenuIsOpened,
  appointmentTypes: state.appointmentTypesReducer.appointmentTypes,
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSlotGroup);